import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  loading?: boolean;
  placeholder?: string;
  children: React.ReactNode;
  renderValue?: (value: string) => React.ReactNode;
  size?: 'small' | 'medium';
}

export const Selector: React.FC<Props> = (props) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        id={`${props.id}-label`}
        shrink
        className="relative transform-none text-gray-900 font-medium pb-1"
      >
        {props.label}
      </InputLabel>
      <Select
        displayEmpty
        value={props.value}
        labelId={`${props.id}-label`}
        fullWidth
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disabled}
        className="shadow-sm"
        size={props.size}
        renderValue={(value) => {
          if (props.loading) {
            <div className="flex items-center space-x-2">
              <CircularProgress size={16} />
              <span>Loading…</span>
            </div>;
          }

          if (!value) {
            return props.placeholder || '';
          }

          if (props.renderValue) {
            return props.renderValue(value);
          }

          return value;
        }}
      >
        {props.placeholder && (
          <MenuItem value="" disabled>
            {props.placeholder}
          </MenuItem>
        )}
        {props.children}
      </Select>
    </FormControl>
  );
};
Selector.displayName = 'Selector';
